export default "__VITE_ASSET__CUAXjPFG__"